export default __webpack_public_path__ + "static/media/projiect1.c2f6d50b.ifc";